/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post,postDownload, tokenPost} from "./ajax";

const material = {
  /**
   *  AJAX-获取货品列表（分页）
   * @param search
   * @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listMaterial(search, page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_MATERIAL,
      {
        keys: search.id,
        serialId: search.serialId,
        typeId: search.typeId,
        isStop: search.statusId,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-导出库存单
   * @param search
   * @param success
   * @param isLoadingExplicit
   * @param errorHandler
   */
  exportMaterial(search, success, isLoadingExplicit, errorHandler){
    postDownload.bind(this)(
      url.EXPORT_MATERIAL,
      {
        keys: search.id,
        serialId: search.serialId,
        typeId: search.typeId,
        isStop: search.statusId,
      },
      success,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取货品详情
   *  @param id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquireMaterialDetail(id, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_MATERIAL_DETAIL,
      {
        id: id,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-启用/停用物料
   * @param id
   * @param flag
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  stopMaterial(id, flag, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.STOP_MATERIAL,
      {
        id: id,
        flag: flag,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-添加物料信息
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addMaterial(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_MATERIAL,
      {
        materialNum : info.materialNum,
        materialName : info.materialName,
        spellCode : info.spellCode,
        materialSerialId : info.serialId,
        materialTypeId : info.typeId,
        purchaseUnitId : info.purchaseUnitId,
        dcStockUnitId : info.dcStockUnitId,
        shopStockUnitId : info.shopStockUnitId,
        formulaUnitId : info.formulaUnitId,
        shopRate : info.shopRate,
        formulaRate : info.formulaRate,
        purchaseRate : info.purchaseRate,
        materialSpecs : info.materialSpecs,
        isStop : info.isStop,
        isCpt : info.isCptChecked,
        isFrozen : info.isFrozenChecked,
        isDept : info.isDeptChecked,
        isProduce : info.isProduceChecked,
        transitDay: 0,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-修改物料信息
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modifyMaterial(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_MATERIAL,
      {
        materialNum : info.materialNum,
        materialName : info.materialName,
        spellCode : info.spellCode,
        materialSerialId : info.serialId,
        materialTypeId : info.typeId,
        purchaseUnitId : info.purchaseUnitId,
        dcStockUnitId : info.dcStockUnitId,
        shopStockUnitId : info.shopStockUnitId,
        formulaUnitId : info.formulaUnitId,
        shopRate : info.shopRate,
        formulaRate : info.formulaRate,
        purchaseRate : info.purchaseRate,
        materialSpecs : info.materialSpecs,
        isStop : info.isStop,
        isCpt : info.isCptChecked,
        isFrozen : info.isFrozenChecked,
        isDept : info.isDeptChecked,
        isProduce : info.isProduceChecked,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

}

export default material;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-material.js